import { render } from "./IAlbumsRow.vue?vue&type=template&id=36c9acff&scoped=true"
import script from "./IAlbumsRow.vue?vue&type=script&lang=js"
export * from "./IAlbumsRow.vue?vue&type=script&lang=js"

import "./IAlbumsRow.vue?vue&type=style&index=0&id=36c9acff&lang=sass&scoped=true"

import exportComponent from "/Users/ilya/Documents/Web/github/iTunes-Vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c9acff"]])

export default __exports__